import { useContext, useEffect } from 'react';
import { StepsProgressContext } from 'components/Booking-new/providers/steps';

/**
 * Access progress value of a progress bar and also the API provides
 * goToPrevProgress and goToNextProgress functions to progress
 * a bar one step backward or forward respectively.
 *
 * TODO: Add the following
 * -- Function to go to any step
 * -- Avoid bar's value to go less than 0 or beyond max step
 */
export default function useStepsProgress(totalStepsCount = 0) {
  const contextConsumer = useContext(StepsProgressContext);
  const { activeStepIndex, allStepsCount, goToPrevProgress, goToNextProgress, setAllStepsCount } = contextConsumer;

  useEffect(() => {
    if (totalStepsCount === 0 || typeof totalStepsCount !== 'number') return;

    setAllStepsCount(totalStepsCount);
  }, [totalStepsCount]);

  const progressValue = activeStepIndex / allStepsCount;

  return { progressValue, goToPrevProgress, goToNextProgress, setAllStepsCount };
}
